<template>
  <div class="container h-max w-max is-family-secondary">
    <div id="a1" style="background-image: url(static/marketing/shutterstock_1020086572.jpg);" class="h-max w-max front-img">
        <div style="background-image: linear-gradient(to left, transparent 60%, #ffffff);height:50%;" class="w-max front-logo">
          <div class="p-t-sm p-l-md">
            <p><img src="static/keepyou.fit.svg" class="icon is-xlarge"></p>
            <p class="is-uppercase is-size-3 has-text-black lh-1 has-text-weight-bold">Fitness <br>& Diet</p>
        </div>
        <div style="position:absolute;top:1rem;right:1rem;"><a href="http://www.google.at">
        <img src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIzLjAuMSwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkViZW5lXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAyNTAgMjUwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAyNTAgMjUwOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+Cgkuc3Qwe2ZpbGw6IzQ4Qjg5RTt9Cjwvc3R5bGU+Cjx0aXRsZT5aZWljaGVuZmzDpGNoZSA1PC90aXRsZT4KPHBhdGggY2xhc3M9InN0MCIgZD0iTTEzNi42LDEyNWw1MS40LTUxLjRjMy4yLTMuMiwzLjItOC40LDAtMTEuNWMtMy4yLTMuMi04LjQtMy4yLTExLjUsMEwxMjUsMTEzLjRMNzMuNiw2Mi4xCgljLTMuMy0zLjEtOC40LTMtMTEuNSwwLjNjLTMsMy4yLTMsOC4xLDAsMTEuMmw1MS40LDUxLjRsLTUxLjQsNTEuNGMtMy4zLDMuMS0zLjQsOC4zLTAuMywxMS42YzMuMSwzLjMsOC4zLDMuNCwxMS41LDAuMwoJYzAuMS0wLjEsMC4yLTAuMiwwLjMtMC4zbDUxLjQtNTEuNGw1MS40LDUxLjRjMy4yLDMuMiw4LjQsMy4yLDExLjUsMGMzLjItMy4yLDMuMi04LjQsMC0xMS41bDAsMEwxMzYuNiwxMjV6Ii8+Cjwvc3ZnPgo=" class="is-inline-block is-large icon">
        </a></div>
    </div>
        <div style="height:50%;background-color: #2c272b !important;" class="has-text-centered">
              <p class="is-size-5 p-sm" style="max-width: 900px; margin: auto;">Bleib immer fit und schliesse dich KeepYouFit an! Streame alle Trainingvideos, erstelle einen individuellen Trainingsplan und erhalte Ernährung Tips für die Dauer des Abonnements. Trainiere bequem aus deinem Haus. Für die Ausführung aller Übungen benötigt man kein Fitnessgerät oder Hanteln. Kosten: EUR 5.00 / Woche. Diese Kosten werden mit der monatlichen Mobilfunkrechnung verrechnet. </p>
              <a class="button is-primary is-rounded is-size-4 p-l-xl p-r-xl m-b-md m-t-md  is-uppercase has-text-weight-bold" :href="link">Weiter zum Kauf</a>
              <p class="is-size-7 p-sm m-t-lg">Nach dem Abschluss des Abonnements bei Keep You Fit erhält der Benutzer die Möglichkeit, alle bereitgestellten Training Videos und Ernährung Tips für die Dauer des Abonnements zu nutzten. Preis: 5.00€ / Woche. Dienstanbieter: Business Fleet s.r.o. Lidická 700/19 |&nbsp;Veveří, 602 00 Brno |&nbsp;Czech Republic, Steuer-Nr.: CZ24814776. Der Benutzer kann sein Abonnement jederzeit unter der telefonischen Hotline:         Telefon: <a href="tel:0800100299">0800100299</a><br>
 oder beim E-Mail-Support: <a href="mailto:businessfleet.at@silverlines.info">businessfleet.at@silverlines.info</a> kündigen. Der Benutzer kann den Dienst direkt über den Link „Abo-Verwaltung“ selbstständig verwalten/kündigen. A1 Nutzer: kündige dein Abo auf http://www.a1.net/meina1 . T-Mobile Nutzer: kündige dein Abo auf www.t-mobile.at/zahlungsdienste. Tele.Ring Nutzer: kündige dein Abo auf www.telering.at/zahlungsdienste</p>
        <p>

      <a class="has-text-light m-r-sm m-l-sm" href="http://at.keepyou.fit/#/terms-and-conditions">AGB</a> | 
      <a class="has-text-light m-r-sm m-l-sm" href="http://at.keepyou.fit/#/deactivation">Abo-Verwaltung</a> | 
      <a class="has-text-light m-r-sm m-l-sm" href="http://at.keepyou.fit/#/imprint">Impressum</a> | 
      <a class="has-text-light m-r-sm m-l-sm" href="http://at.keepyou.fit/#/data-protection">Datenschutzerklärung</a> | 
      <a class="has-text-light m-r-sm m-l-sm" href="http://at.keepyou.fit/#/help">Hilfe</a> | 
      <a class="has-text-light m-r-sm m-l-sm" href="http://at.keepyou.fit/#/privacy">Nutzungsbedingungen</a>
      <a class="has-text-light m-r-sm m-l-sm" href="http://at.keepyou.fit/#/right-of-withdrawal">Hinweis auf Rücktrittsrecht </a>
        </p>
        </div>
  </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Statisitc',
  data () {
    let link = `http://tb.premium-billing.info/1-kyf-at/`
    const requestIdArr = document.location.toString().match(/request_id=(.*)/)
    if (requestIdArr !== null) {
      link = `http://tb.premium-billing.info/1-kyf-at/?${ requestIdArr[0] }`
    }
    return {
      profile: this.$store.getters.getProfile,
      link
    }
  },
  async mounted() {
    if (this.$store.getters.requireSaleId && window !== undefined && window.localStorage instanceof Storage && window.localStorage.getItem('saleId') !== null) {
      const result = await axios.get(`/${ this.$store.getters.apiPrefix }/checkSale/${ window.localStorage.getItem('saleId') }`)
      if (result.data.state === 'open') {
        this.$router.push({ name: 'Home' })
      }
    }
  },
  methods: {
    updateProfile () {
      this.profile.age = parseInt(this.profile.age)
      this.profile.height = parseInt(this.profile.height)
      this.profile.weight = parseInt(this.profile.weight)
      this.$store.dispatch('updateProfile', this.profile)
    }
  }
}
</script>

<style>
.is-vertical-center {
display: flex;
align-items: center;
}
.shadow {
-webkit-box-shadow: 5px 5px 10px 5px rgba(0,0,0,0.1);
-moz-box-shadow: 5px 5px 10px 5px rgba(0,0,0,0.1);
box-shadow: 5px 5px 10px 5px rgba(0,0,0,0.1);
}
.steps .steps-marker {
    background: linear-gradient(to bottom, rgba(0,0,0,0) 0%,rgba(0,0,0,0.1) 100%);
}

.h-max {
    min-height: 100%;
    height: 100%;
}
.w-max {
    min-width: 100%;
    width: 100%;
}
.fixed-tl {
    position: fixed;
    top:0;
    left: 0;
}
.fixed-bl {
    position: fixed;
    bottom:0;
    left: 0;
}
.fixed-tr {
    position: fixed;
    top:0;
    right: 0;
}
.fixed-br {
    position: fixed;
    bottom:0;
    right: 0;
}
.lh-1 {
    line-height: 1 !important;
}
.bg-point {
    background-color: transparent;
    background-image: radial-gradient(#f99819 50%, transparent 51%, transparent 60%, #f99819 61%, #f99819 65%, transparent 66%);
}

.front-img {
    background-repeat: no-repeat;
    background-position: top center;
    background-size: auto 120%;
}
.invert-img {
    background-repeat: no-repeat;
    background-position: top center;
    background-size: 100% auto;
}
@media screen and (orientation:landscape) {
    .front-img {
        background-size: 100% auto;
    }
    .invert-img {
        background-size: auto 100%;
        background-position: top left;
    }
    .front-logo {
        display: block;
    }
    .is-portrait {
        display: none;
    }
}
@media screen and (orientation:portrait) {
    .is-landscape {
        display: none;
    }
    .front-img {
        background-size: auto 60%;
    }
    .lp-logo {
        position: absolute;
        bottom: 40%;
        margin-bottom: -7.2rem;
    }
}
</style>




// WEBPACK FOOTER //
// src/components/LangKyf/AT/LP.vue